/**
 * Created by anthony on 7/10/14.
 */
var standardModalCud = angular.module('standardModalCud', ['classy', 'standardCudFactory']);
standardModalCud.factory('StandardModalCudFactory', function($timeout, StandardCudFactory)
{
    var StandardModalCudFactory = function(model, id, item, ctrl, dirtyVars, index, $modalInstance)
    {
        ctrl.$.item = item;
        ctrl.$.index = index;
        ctrl.$.$modalInstance = $modalInstance;
        StandardCudFactory.apply(this, arguments)

    };
    StandardModalCudFactory.prototype = new StandardCudFactory();
    StandardModalCudFactory.prototype.parent = StandardCudFactory.prototype;
    StandardModalCudFactory.prototype.closeModal = function(controller)
    {
        if (typeof controller !== 'undefined')
            this.controller = controller;
        var itemIndex = {item: this.controller.$.item, index: this.controller.index}
        var parent = this;
        $timeout(function() {
            parent.controller.$modalInstance.close(itemIndex);
        }, 500);
    }
    StandardModalCudFactory.prototype.successSave = function(scope, instance)
    {
        this.parent.successSave.apply(this, arguments);
        this.closeModal();
    }
    StandardModalCudFactory.prototype.successDelete = function(scope, instance)
    {
        this.parent.successDelete.apply(this, arguments);
        this.controller.index = -1;
        this.closeModal();
    }
    return StandardModalCudFactory;
});

